export type PhysicsForceSet = {
	collision: boolean;
	structural: boolean;
};

export const physicsForceSetFor = (graph: {
	isPhysicsActive(): boolean;
	usesStructuralForces(): boolean;
}): PhysicsForceSet => ({
	collision: graph.isPhysicsActive(),
	structural: graph.isPhysicsActive() && graph.usesStructuralForces(),
});
